import { styled, Typography } from '@material-ui/core';
import { Link } from 'react-router';

export const LinkContainer = styled(Link)({
	'fontFamily': 'inherit',
	'fontSize': 'inherit',
	'color': 'inherit',
	'display': 'flex',
	'textDecoration': 'none',
	'&:hover': {
		textDecoration: 'none',
	},
});

export const HeaderContainer = styled('div')({
	display: 'flex',
	alignItems: 'center',
	marginBottom: 20,
});

export const BodyContainer = styled('div')({
	width: '100%',
	maxWidth: '100%',
	height: 'auto',
	borderRadius: 5,
	background: 'var(--color-bg-primary)',
	padding: 20,
	boxSizing: 'border-box',
});

export const HeaderText = styled(Typography)({
	fontFamily: 'var(--font-family-medium)',
	textTransform: 'capitalize',
	fontSize: 'var(--text-body-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	marginRight: 5,
	color: 'var(--color-brand-primary)',
});

export const HeaderTextNumbers = styled(Typography)({
	fontFamily: 'var(--font-family-medium)',
	textTransform: 'capitalize',
	fontSize: 'var(--type-xs)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-brand-primary)',
	width: 'max-content',
	height: 17.15,
	background: 'var(--color-brand-primary-light)',
	borderRadius: 3,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: '0 8px',
});
